/**
 * @module app.track.filterlist
 */
import appBase from '../index.js';
import {TRACK_FILTER_ID} from "../constants";

class Controller {
  /**
   * @param {app.track.filterService} appTrackFilterService
   * @param {angularGettext.Catalog} gettextCatalog
   * @ngInject
   */
  constructor(appTrackFilterService, gettextCatalog) {

    /**
     * @type {app.track.filterService}
     * @export
     */
    this.appTrackFilterService = appTrackFilterService;

    /**
     * @type {angularGettext.Catalog}
     * @protected
     */
    this.gettextCatalog = gettextCatalog;

    /**
     * @type {function(appx.TrackFilterChangeEvent)}
     * @export
     */
    this.onFilterSelected;
  }


  $onInit() {
    this.appTrackFilterService.updateList();
  }

  /**
   * @export
   */
  showAll() {
    this.updateSelectedFilter({
      id: TRACK_FILTER_ID.ALL,
      name: this.gettextCatalog.getString('all tours'),
    });
  }

  /**
   * @export
   */
  showOther() {
    this.updateSelectedFilter({
      id: TRACK_FILTER_ID.OTHER,
      name: this.gettextCatalog.getString('undefined filter'),
    });
  }

  /**
   * @param {appx.TrackFilter} filter
   * @export
   */
  updateSelectedFilter(filter) {
    this.onFilterSelected({
      filter: filter
    });
  }

  /**
   * @export
   * @return {string}
   */
  getTrackFilterText() {
    return this.gettextCatalog.getString(this.appTrackFilterService.trackListFilter.name);
  }
}

/**
 * @const {!angular.Component}
 */
const component = {
  bindings: {
    'onFilterSelected': '&',
  },
  controller: Controller,
  templateUrl: 'js/app/track/filters/partial_list.html',
};


export default appBase.component('appTrackFilterList', component);
